export default __webpack_public_path__ + "static/media/morning.fc016311.svg";